import { SearchHit } from './search-hit.model';

export class SearchResultMeta {
  /** Results returned, after max_results. */
  count!: number;
  /** How many documents matched before the cut. */
  totalMatches: number | null = null;
  sortBy: string | null = null;
  sortDirection: string | null = null;
  /** The columns actually returned, url first. */
  fields: string[] = [];
  parametersEcho: Record<string, unknown> = {};

  constructor(data: any = {}) {
    this.count = data.count;
    this.totalMatches = typeof data.total_matches === 'number' ? data.total_matches : null;
    this.sortBy = data.sort_by ?? null;
    this.sortDirection = data.sort_direction ?? null;
    this.fields = data.fields ?? [];
    this.parametersEcho = data.parameters_echo ?? {};
  }
}

/** The data object of a /search response, per the documented
 *  `search_result` schema (docs-api-data.ts). */
export class SearchResult {
  query!: string;
  results: SearchHit[] = [];
  meta!: SearchResultMeta;

  constructor(data: any = {}) {
    this.query = data.query;
    this.results = (data.results ?? []).map((hit: object) => new SearchHit(hit));
    this.meta = new SearchResultMeta(data.meta ?? {});
    this.meta.count ??= this.results.length;
  }
}
